import React, { Component } from "react";
import { Button } from "react-bootstrap";
import {
  ContainerBody,
  ContainerWrapper,
  Content,
} from "../../components/GridComponent/AdminLte";
import API from "../../services/API";
import { connect } from "react-redux";
import { fetchYEPPHTicket, checkInYEPPHTicket } from '../../store/actions/modal/modalActions';

class EventCheckin extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    submitting: false,
  };

  componentDidMount() {
    this.mounted = true;
    console.log(this.state);
    if (!this.props.ticket) {
      this.props.fetchYEPPHTicket(this.code());
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  /**
   * Get the ticket code from the route parameters.
   */
  code = () =>
    encodeURIComponent(
      (this.props.params && this.props.params.code) || ""
    );

  /**
   * Submit the check-in request.
   */
  checkIn = async () => {
    if (this.state.submitting) {
      return;
    }

    this.setState({ submitting: true });
    try {
      await this.props.checkInYEPPHTicket(this.code());
    } finally {
      this.setState({ submitting: false });
    }
  };

  /**
   * Display ticket holder information.
   */
  renderTicket(ticket) {
    if (!ticket) {
      return null;
    }

    return (
      <div
        data-testid="event-checkin-ticket"
        style={{
          fontSize: "1.1rem",
          marginBottom: "1rem",
        }}
      >
        <div
          style={{
            fontSize: "1.4rem",
            fontWeight: "bold",
          }}
        >
          {ticket.full_name}
        </div>

        <div>Employee ID: {ticket.emp_num}</div>

        <div>Department: {ticket.department}</div>
      </div>
    );
  }

  /**
   * Render the appropriate check-in state.
   */
  renderBody() {
    const { submitting } = this.state;
    const {
      loading,
      ticket,
      status,
    } = this.props;

    if (loading) {
      return <p>Checking ticket…</p>;
    }

    switch (status) {
      case "not_authorized":
        return (
          <div className="alert alert-danger">
            You are not authorized to check in guests.
          </div>
        );

      case "invalid":
        return (
          <div className="alert alert-danger">
            Invalid ticket. This QR code is not a registered ticket.
          </div>
        );

      case "error":
        return (
          <div className="alert alert-warning">
            Something went wrong. Please scan again.
          </div>
        );

      case "already_used":
        return (
          <>
            <div className="alert alert-warning">
              This ticket has already been used
              {ticket?.checked_in_at
                ? ` (${ticket.checked_in_at})`
                : ""}
              .
            </div>

            {this.renderTicket(ticket)}
          </>
        );

      case "checked_in":
        return (
          <>
            <div className="alert alert-success">
              Checked in! Welcome.
            </div>

            {this.renderTicket(ticket)}
          </>
        );

      default:
        return (
          <>
            {this.renderTicket(ticket)}

            <Button
              variant="primary"
              size="lg"
              block
              disabled={submitting}
              onClick={this.checkIn}
            >
              {submitting ? "Checking in…" : "Check in"}
            </Button>
          </>
        );
    }
  }

  render() {
    const { ticket } = this.state;

    return (
      <ContainerWrapper>
        <ContainerBody>
          <Content
            col="12"
            title={
              ticket?.event_title || "Event Check-in"
            }
          >
            {this.renderBody()}
          </Content>
        </ContainerBody>
      </ContainerWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    settings: state.settings,
    ticket: state.modal.yep_ph_ticket,
    loading: state.modal.loading,
    status: state.modal.status,
    submitting: state.modal.submitting
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchYEPPHTicket: (ticket_code) => dispatch(fetchYEPPHTicket(ticket_code)),
    checkInYEPPHTicket: (ticket_code) => dispatch(checkInYEPPHTicket(ticket_code)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventCheckin);